import React, { ComponentProps } from 'react'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getFromDurationI18nKey } from 'selectors/offerPageSelectors'
import { capitalise } from 'lib/stringUtils'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { useTranslation } from 'react-i18next'

interface Props extends ComponentProps<typeof BodyText> {
  durationI18nKey: {
    key: string;
    options: Record<string, string | number> & { ns: string };
  }
}

function OfferFromDurationLabel(props: Props) {
  const { durationI18nKey, ...rest } = props

  const { t } = useTranslation(['offerList', 'hotelOfferList'])

  const durationLabel = t(durationI18nKey.key, durationI18nKey.options)

  return (
    <BodyText {...rest}>
      {capitalise(durationLabel.toLowerCase())}
    </BodyText>
  )
}

export default withOfferPageAndReduxState((state, appState) => ({
  durationI18nKey: getFromDurationI18nKey(state, appState),
}))(OfferFromDurationLabel)
